{
  "fr": {
    "voiceRecorder": {
      "hints": {
        "transcribing": "Créer une transcription d'enregistrement audio..."
      }
    }
  }
}
